import axios from 'axios';
import { smallNotification } from '@shared/services/gf.notification.service';
import HelperS from './helper.service';
import store from '../../store';

export default {
  getLangs(params) {
    return axios
      .get(`/reference/language`, { params })
      .then((res) => HelperS.parsePagination(res.data))
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getRepoLabels(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/reference/label`, {
        params: { size: 100, ...params }
      })
      .then((res) => store.dispatch('setRefRepoLabels', HelperS.parsePagination(res.data)))
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getIssuesRefUsers(alias, projectAlias, params) {
    return axios
      .get(`/project/${alias}/${projectAlias}/reference/project-issue-creators`, {
        params: { ...params }
      })
      .then((res) => {
        store.dispatch('setIssuesRefUsers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  getRefUsers(params) {
    return axios
      .get(`/reference/user`, { params })
      .then((res) => {
        store.dispatch('setReferenceUsers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        console.log(err);
        // throw err;
      });
  },
  getRefTeamUsers(teamAlias, params) {
    return axios
      .get(`/api/team/${teamAlias}/reference/user`, { params })
      .then((res) => {
        store.dispatch('setReferenceTeamUsers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        console.log(err);
        // throw err;
      });
  },
  getRefCompanyUsers(companyAlias, params) {
    return axios
      .get(`/api/company/${companyAlias}/reference/user`, { params })
      .then((res) => {
        store.dispatch('setReferenceCompanyUsers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        console.log(err);
        // throw err;
      });
  },
  getProjectRefUsers(alias, projectAlias, params) {
    return axios
      .get(`/project/${alias}/${projectAlias}/reference/find-user-to-add`, { params })
      .then((res) => {
        store.dispatch('setReferenceUsers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getRefTeams(params) {
    return axios
      .get(`/reference/team/available`, { params })
      .then((res) => {
        store.dispatch('setReferenceTeams', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getMergeRequestRefUsers(alias, projectAlias, params) {
    return axios
      .get(`/project/${alias}/${projectAlias}/reference/merge-request-assignable-users`, {
        params: { ...params }
      })
      .then((res) => {
        store.dispatch('setReferenceUsers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  getIssueRefUsers(alias, projectAlias, params) {
    return axios
      .get(`/project/${alias}/${projectAlias}/reference/issue-assignable-users`, {
        params: { ...params }
      })
      .then((res) => {
        store.dispatch('setIssuesRefUsers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  getMergeRequestRefUser(alias, projectAlias, params) {
    return axios
      .get(`/project/${alias}/${projectAlias}/reference/user`, {
        params: { size: 1, ...params }
      })
      .then((res) => HelperS.parsePagination(res.data).items)
      .catch((err) => {
        throw err;
      });
  },
  getMergeRequestCreators(alias, projectAlias, params) {
    return axios
      .get(`/project/${alias}/${projectAlias}/reference/merge-request-creators`, {
        params: { ...params }
      })
      .then((res) => HelperS.parsePagination(res.data))
      .catch((err) => {
        throw err;
      });
  },
  getMergeRequestAssigners(alias, projectAlias, params) {
    return axios
      .get(`/project/${alias}/${projectAlias}/reference/merge-request-assigners`, {
        params: { ...params }
      })
      .then((res) => HelperS.parsePagination(res.data))
      .catch((err) => {
        throw err;
      });
  },
  getProjectIssueCreators(alias, projectAlias, params) {
    return axios
      .get(`/project/${alias}/${projectAlias}/reference/project-issue-creators`, {
        params: { ...params }
      })
      .then((res) => HelperS.parsePagination(res.data))
      .catch((err) => {
        throw err;
      });
  },
  getProjectIssueAssigners(alias, projectAlias, params) {
    return axios
      .get(`/project/${alias}/${projectAlias}/reference/project-issue-assigners`, {
        params: { ...params }
      })
      .then((res) => HelperS.parsePagination(res.data))
      .catch((err) => {
        throw err;
      });
  },
  getRefIssueStatuses(alias, projectAlias, params) {
    return axios
      .get(`/project/${alias}/${projectAlias}/reference/issue-status`, { params })
      .then((res) => {
        store.dispatch('setIssueStatuses', res.data);
        return res.data;
      });
  },
  getProjects(params) {
    return axios
      .get(`/api/reference/user/project`, {
        params: HelperS.getRealPagination(params)
      })
      .then((res) => {
        store.dispatch('setProjectsRef', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        // throw err;
      });
  },
  getProjectPaths(userAlias, projectAlias, params) {
    return axios
      .get(`/api/search/${userAlias}/${projectAlias}/package`, { params })
      .then((res) => res.data);
  },
  getProjectFiles(userAlias, projectAlias, params) {
    return axios
      .get(`/api/search/${userAlias}/${projectAlias}/file`, { params })
      .then((res) => res.data);
  },
  getProjectForks(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/reference/fork`, { params })
      .then((res) => {
        store.dispatch('setForksRef', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  getSastStatus() {
    const element = document.getElementById('sastIsEnabled');
    if (!element) return;
    const { value } = element;
    const flag = value === 'true';
    store.dispatch('setSastStatus', flag);
    // eslint-disable-next-line consistent-return
    return flag;
  },
  getCicdStatus() {
    const element = document.getElementById('cicdIsEnabled');
    if (!element) return;
    const { value } = element;
    const flag = value === 'true';
    store.dispatch('setCicdStatus', flag);
    // eslint-disable-next-line consistent-return
    return flag;
  },
  getRefTopics(params) {
    return axios
      .get(`/reference/topic`, { params })
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getProjectTopics(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/topic`, { params })
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  }

  // api/project/{userAlias}/{projectAlias}/topic
};
